import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import pakt21ApiUrl from '../../common/pakt21ApiUrl';

export default class LoungeModerationModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.message = this.attrs.message;
    this.reason = Stream('');
  }

  className() {
    return 'Pakt21ModerationDecisionModal Modal--small';
  }

  title() {
    return app.translator.trans('pakt21-beta.forum.lounge_moderation.hide_title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">
          <p className="helpText">
            {app.translator.trans('pakt21-beta.forum.lounge_moderation.hide_help')}
          </p>
          <div className="Form-group">
            <label for="pakt21-lounge-moderation-reason">
              {app.translator.trans('pakt21-beta.forum.moderation.reason_label')}
            </label>
            <textarea
              id="pakt21-lounge-moderation-reason"
              className="FormControl"
              rows="5"
              maxlength="500"
              required
              bidi={this.reason}
            />
            <p className="helpText">
              {app.translator.trans('pakt21-beta.forum.moderation.reason_help')}
            </p>
          </div>
          <div className="Form-group">
            <Button
              className="Button Button--danger Button--block"
              type="submit"
              loading={this.loading}
              disabled={!this.reason().trim()}
            >
              {app.translator.trans('pakt21-beta.forum.lounge_moderation.hide_submit')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(event) {
    event.preventDefault();

    const reason = this.reason().trim();
    if (!reason || this.loading) return;

    this.loading = true;

    return app
      .request({
        method: 'POST',
        url: pakt21ApiUrl(app.forum.attribute('apiUrl'), `/pakt21/lounge/messages/${this.message.id}/hide`),
        body: {
          data: {
            type: 'pakt21-lounge-moderation-decisions',
            attributes: { reason },
          },
        },
      })
      .then(() => {
        this.attrs.onHidden(this.message.id);
        this.hide();
      })
      .catch((error) => {
        this.loading = false;
        this.onerror(error);
      });
  }
}
